/**
 * Bootstrap JavaScript dependencies that are available in the global scope.
 */

require('./bootstrap')

/**
 * Import libraries that are used by the application.
 */
import vuetify from './plugins/vuetify'
import VueAuth from '@websanova/vue-auth'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import {i18n} from './plugins/i18n'
import VeeValidate from 'vee-validate'
import VueQRCodeComponent from 'vue-qrcode-component'
import VueGallery from 'vue-gallery'
import VueGoogleCharts from 'vue-google-charts'
import CKEditor from '@ckeditor/ckeditor5-vue'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import Vue from "vue"
import VueSimpleAlert from "vue-simple-alert"
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Store
import store from './store'
// Set Vue router
import router from './routes.js'
// Set Vue authentication
import auth from './api/auth.js'
import EmojiPicker from '@zaichaopan/emoji-picker';
/* Layout */
import App from './views/layouts/AppLayout.vue'

import VueDatepickerUi from 'vue-datepicker-ui'
import 'vue-datepicker-ui/lib/vuedatepickerui.css';

// Custom components
import Confirm from './views/components/ui/Confirm.vue';
import Snackbar from './views/components/ui/Snackbar.vue';
import DateTimePicker from './views/components/ui/DateTimePicker.vue';
import DateRangePicker from './views/components/ui/DateRangePicker.vue';
import ColorPicker from './views/components/ui/ColorPicker.vue';
import DataTable from './views/components/DataTable.vue';
import DataForm from './views/components/DataForm.vue';
import VueApexCharts from 'vue-apexcharts';

/**
 * Enable Vue libraries.
 */
Vue.use(Vuex)
Vue.component('qr-code', VueQRCodeComponent)
Vue.use(VeeValidate)
Vue.component('vue-gallery', VueGallery)
Vue.use(VueGoogleCharts)
Vue.use(CKEditor)
Vue.use(VueSimpleAlert)
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)


Vue.config.productionTip = false

Vue.router = router
Vue.use(VueRouter)

Vue.use(VueAxios, axios)
Vue.use(VueAuth, auth)

Vue.use(EmojiPicker);


Vue.component('confirm', Confirm)

Vue.component('snackbar', Snackbar)

Vue.component('date-time-picker', DateTimePicker)

Vue.component('date-range-picker', DateRangePicker)

Vue.component('Datepicker', VueDatepickerUi)

Vue.component('color-picker', ColorPicker)

Vue.component('data-table', DataTable)

Vue.component('data-form', DataForm)


Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)



/**
 * Initialize the app.
 */
const app = new Vue({
  vuetify,
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')